import { type FC, useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  type ContactFormState,
  useContactFormApiPostMutation,
} from '../../../../contact-form'
import { FriendlyCaptchaChallenge } from '../../../../friendly-captcha'
import { type OpenableControls } from '../../../../generic-hooks'
import { useUserApiSwrSessionV1Customer } from '../../../../user-data'
import { useDirectContactFormUpdateFormStateWithUserData } from '../../../hooks/useDirectContactFormUpdateFormStateWithUserData'
import { DirectContactFormEmailInputField } from '../DirectContactFormEmailInputField'
import { DirectContactFormMessageInputField } from '../DirectContactFormMessageInputField'
import { DirectContactFormPhoneNumberField } from '../DirectContactFormPhoneNumberField'
import { DirectContactFormSelectSubjectField } from '../DirectContactFormSelectSubjectField'
import { DirectContactFormSubmitButton } from '../DirectContactFormSubmitButton'
import { DirectContactFormTextInfoSection } from '../DirectContactFormTextInfoSection'

export const DirectContactFormOtherTypeForm: FC<{
  formState: ContactFormState
  onFormSubmittedWithSuccess: () => void
  userModalControls: OpenableControls
}> = ({ formState, onFormSubmittedWithSuccess, userModalControls }) => {
  const submitMutation = useContactFormApiPostMutation()

  const { data: userData } = useUserApiSwrSessionV1Customer()
  const isLoggedIn = Boolean(userData?.customerNumber)

  useDirectContactFormUpdateFormStateWithUserData(formState)

  const [isFriendlyCaptchaDone, setIsFriendlyCaptchaDone] =
    useState<boolean>(false)

  const captchaDoneCallback = useCallback(
    (fcSolution: string): void => {
      formState.setValue(fcSolution, formState.model, 'fcSolution')
      setIsFriendlyCaptchaDone(true)
    },
    [formState],
  )

  return (
    <>
      <p className="mb-2 text-xs text-dark-primary-strong">
        <FormattedMessage id="general.form.label.mandatoryFieldIndicator" />
      </p>

      {isLoggedIn ? null : (
        <DirectContactFormEmailInputField formState={formState} />
      )}

      <DirectContactFormPhoneNumberField formState={formState} />

      <DirectContactFormSelectSubjectField formState={formState} />

      <DirectContactFormMessageInputField formState={formState} />

      <DirectContactFormTextInfoSection />

      <FriendlyCaptchaChallenge
        className="mb-3.5"
        doneCallback={captchaDoneCallback}
        startMode="auto"
        whenThisPropChangesResetCaptcha={submitMutation.error}
      />

      <DirectContactFormSubmitButton
        formState={formState}
        isFriendlyCaptchaDone={isFriendlyCaptchaDone}
        modalControls={userModalControls}
        onFormSubmittedWithSuccess={onFormSubmittedWithSuccess}
        submitMutation={submitMutation}
      />
    </>
  )
}
